import classNames from 'classnames';
import React, { CSSProperties, ReactNode, useMemo } from 'react';
import { IDivProps } from '../../types/props/DivProps';
import FlexItem from '../FlexItem/FlexItem';
import './FlexContainer.scss';

type AlignItems = CSSProperties['alignItems'];
type AlignContent = CSSProperties['alignContent'];
type Flex = CSSProperties['flex'];
type FlexFlow = CSSProperties['flexFlow'];
type FlexWrap = CSSProperties['flexWrap'];
type FlexDirection = CSSProperties['flexDirection'];
type JustifyContent = CSSProperties['justifyContent'];
type JustifyItems = CSSProperties['justifyItems'];

export interface IFlexContainerProps extends Omit<IDivProps, 'style' | 'className'> {
  children: ReactNode;
  flex?: Flex;
  flexDirection?: FlexDirection;
  flexWrap?: FlexWrap;
  flexFlow?: FlexFlow;
  justifyContent?: JustifyContent;
  justifyItems?: JustifyItems;
  alignContent?: AlignContent;
  alignItems?: AlignItems;
  style?: Omit<CSSProperties, 'alignItems' | 'alignContent' | 'flex' | 'flexFlow' | 'flexDirection' | 'justifyContent'>;
  className?: string | object;
}

function FlexContainer({ children, className, style, ...flexStyles }: IFlexContainerProps) {
  const styles = useMemo(
    () => ({
      ...style,
      ...flexStyles,
    }),
    [style, flexStyles]
  );

  return (
    <div className={classNames('flex-container', className)} style={styles}>
      {children}
    </div>
  );
}

FlexContainer.Item = FlexItem;

export default FlexContainer;
